module.exports = __webpack_public_path__ + "static/media/naviguard_color_desktop.24eabcac.svg";